var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"authentication-wrapper authentication-1 px-4"},[_c('div',{staticClass:"authentication-inner py-5"},[(_vm.showLoader)?_c('loader'):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("Loading...")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e73ba2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/dashboard/components/UserSetup.vue
// module id = null
// module chunks = 